<template>
    <div class="sa-free-page">
        <div class="sa-free-page-header">
            <b-card class="sa-card sa-card-border" header="Dettagli Laboratorio" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice</label>
                        <span class="sa-data">{{ jsonData.codiceReparto }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Denominazione</label>
                        <span class="sa-data">{{ jsonData.descrizioneReparto }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div class="sa-free-page-body">
            <b-card class="sa-card sa-card-border" header="Lista Utenti" header-tag="header" footer-tag="footer" title="">
                <b-button size="sm" variant="outline-info outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAssociaUtenti" class="mb-2"> <b-icon icon="people-fill"></b-icon> Associa Utente</b-button>
                <b-table sticky-header ref="table" stacked="lg" :key="listKey" striped hover :items="jsonData.listaUtenti" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover title="Elimina Associazione" variant="outline-danger" @click="onDeleteAssociazione(row)"><b-icon icon="person-x-fill" aria-hidden="true"></b-icon></b-button>
                        </b-container>
                    </template>
                </b-table>
            </b-card>
        </div>
        <!-- <rsa-configurazione-laboratori-reparti-edit-modal-component ref="mdlNuovoReparto" @onSave="onSave"></rsa-configurazione-laboratori-reparti-edit-modal-component> -->
        <rsa-configurazione-associa-utente-laboratorio-modal-component ref="mdlAssociaUtenteLaboratorio" @afterAssociazione="onAfterAssociazione"></rsa-configurazione-associa-utente-laboratorio-modal-component>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneAssociaUtenteLaboratorioModalComponent from "./RsaConfigurazioneAssociaUtenteLaboratorioModalComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaConfigurazioneAssociaUtenteLaboratorioModalComponent },
    data() {
        return {
            id: null,
            strutturaOptions: [],
            pathResource: "/rsalaboratorireparti",
            jsonData: {},
            showModalLoading: false,
            idLaboratorio: null,
            perPage: 10000,
            listKey: 100,
            currentPage: 1,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 2rem",
                },
                {
                    label: "Username",
                    key: "username",
                    sortable: true,
                    thStyle: "width: 25rem",
                },
                {
                    label: "Nome",
                    key: "firstname",
                    sortable: true,
                    thStyle: "width: 25rem",
                },
                {
                    label: "Cognome",
                    key: "lastname",
                    sortable: true,
                    thStyle: "width: 25rem",
                },
                {
                    label: "Profilo",
                    key: "profilo",
                    sortable: true,
                    thStyle: "width: 25rem",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    methods: {
        init() {
            let me = this;
            // me.idLaboratorio = id;
            me.idLaboratorio = this.$route.params.id;
            me.loadData();
        },
        loadData() {
            let me = this;
            let path = me.pathResource + "/" + me.idLaboratorio;
            UtilityMixin.methods.loadDataResources(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickAssociaUtenti() {
            let me = this;
            me.$refs.mdlAssociaUtenteLaboratorio.init(me.jsonData);
        },
        onClickNuovoReparto() {
            let me = this;
            me.$refs.mdlNuovoReparto.init(me.idLaboratorio);
        },
        onSave(data) {
            console.log(data);

            let me = this;
            me.loadData();
        },
        onView(item) {
            let me = this;
            me.$router.push("/configurazioni/rsaconfigurazionelaboratorireparti/view/" + item.id);
        },
        onAfterAssociazione() {
            let me = this;
            // console.log("ECCOMI");

            me.loadData();
        },
        onDeleteAssociazione(row) {
            let me = this;
            // console.log(row.item);

            me.$refs.mdlAssociaUtenteLaboratorio.deleteAssociazione(row.item);
        },
    },
};
</script>

<style></style>
